// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1pj5-","colCheckbox":"styles_colCheckbox__2AU59"};